var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8339 3.0547C11.5611 3.01862 11.2827 3 11 3C7.52063 3 4.70002 5.82061 4.70002 9.3V11.0504C4.70002 11.6737 4.54497 12.2871 4.24884 12.8355L3.04045 15.0733C2.47924 16.1126 2.92166 17.4096 4.00098 17.8893C8.45687 19.8697 13.5432 19.8697 17.9991 17.8893C19.0784 17.4096 19.5208 16.1126 18.9596 15.0733L18.0633 13.4135C17.7173 13.4704 17.3621 13.5 17 13.5C13.4102 13.5 10.5 10.5899 10.5 7C10.5 5.5163 10.9971 4.14871 11.8339 3.0547Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98682 20.6309C8.72005 21.47 9.79814 22.0001 11 22.0001C12.2019 22.0001 13.28 21.47 14.0133 20.6309C12.0178 20.956 9.98222 20.956 7.98682 20.6309Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12C19.7614 12 22 9.76142 22 7C22 4.23858 19.7614 2 17 2C14.2386 2 12 4.23858 12 7C12 9.76142 14.2386 12 17 12ZM14.5 6.25006H19.5C19.9142 6.25006 20.25 6.58585 20.25 7.00006C20.25 7.41427 19.9142 7.75006 19.5 7.75006H14.5C14.0858 7.75006 13.75 7.41427 13.75 7.00006C13.75 6.58585 14.0858 6.25006 14.5 6.25006Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellRemove);
export default __webpack_public_path__ + "static/media/bell-remove.ff907a15dc2ad33990a5721d1a5e05b2.svg";
export { ForwardRef as ReactComponent };